import React from "react";

import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

const FormField = ({
  keyValue,
  label,
  children,
  tabIndex,
  disabled,
  width,
  errorMessage,
  tooltip,
  textStyle,
  isRequired = false,
}: {
  keyValue?: string;
  label: string | React.ReactElement;
  children: React.ReactElement;
  tabIndex?: number;
  disabled?: boolean;
  width?: string | number;
  errorMessage?: string;
  tooltip?: string;
  textStyle?: React.CSSProperties;
  isRequired?: boolean;
}) => {
  return (
    <div
      key={keyValue}
      tabIndex={tabIndex}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: width || "100%",
        minWidth: width,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: disabled ? "#D9D9D9" : "#4B4B4B",
            height: 14.5,
            ...textStyle,
          }}
        >
          {label}
          {isRequired && (
            <span style={{ color: "#C52F00", marginLeft: 2 }}>*</span>
          )}
        </div>

        {tooltip && (
          <Tooltip title={tooltip} placement="right">
            <InfoIcon style={{ color: "#A7A9AB", height: 18 }} />
          </Tooltip>
        )}
      </div>
      {children}
      {errorMessage && (
        <div style={{ color: "#C52F00", fontSize: 10 }}>{errorMessage}</div>
      )}
    </div>
  );
};

export default FormField;
